<template>
    <div>
        <div>
            <SignInPCB v-if="isPC" />
            <SignInH5B v-else />
        </div>
    </div>
</template>
<script>
    import SignInPCB from '../components/SignInPCBNew';
    import SignInH5B from '../components/SignInH5BNew';
    import { enableAppShare } from '../../../common/js/APP/share';
    export default {
        name: 'Index',
        components: {
            SignInH5B,
            SignInPCB
        },
        data() {
            return {
                isBView:'',//A版      B版
            };
        },
        mounted() {
            enableAppShare({
                title: '如何成长为高级Java工程师',
                desc: '深度匹配一线大厂用人需求，0 基础进阶高级工程师',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20210415/1618467794132.png'
            });
            // this.getPageFn()
        },
        methods: {
            // getPageFn() {
            //     let json_param = JSON.parse(getCookie('JAVA_BASIC')) || {pageVersion: null, pageType: null}
            //     let params = {
            //     pageContext: "JAVA_BASIC",//大数据
            //     pageVersion: json_param.pageVersion,
            //     pageType: json_param.pageType,

            //     }
            //     fetchQueryFN(params).then(res => {
            //     if(res.state == 1) {
            //         if(res.content.hitType == 1) { //命中页面 不返回值
            //             let json_param = JSON.parse(getCookie('JAVA_BASIC')) || {pageVersion: null, pageType: null}
            //             this.isBView = json_param && json_param.pageType == 2 ? 'B' : 'A';
            //         } else if (res.content.hitType == 2) { //刷新页面
            //             this.isBView = res.content && res.content.pageType == 2 ? 'B' : 'A';
            //             let json_param = {
            //                 pageVersion: res.content.pageVersion,
            //                 pageType: res.content.pageType
            //             }
            //             setCookie('JAVA_BASIC', JSON.stringify(json_param))
            //         } else { //未命中 走a版
            //             this.isBView = 'A'
            //         }
            //     } else {
            //         this.isBView = 'A'  //默认a版  报错a版
            //     }
            //     }).catch(error => {
            //         this.isBView = 'A'  //默认a版  报错a版
            //     });
            // },
        },
    };
</script>